import React from "react";
import { cmp } from "./bundle";
import type { ButtonProps } from "./index";

const BundledButton = cmp<ButtonProps>("Button");

/** Reserve balanced activity slots before loading, so the label and measured width stay stable. */
export function Button({ loading, disabled, iconLeft, iconRight, iconOnly, children, ...rest }: ButtonProps) {
  const activity = <span aria-hidden="true" className={`ribbon-btn__activity${!loading && !iconLeft ? " ribbon-btn__activity--idle" : ""}`}>
    {loading ? <span className="neo-btn__spin" /> : iconLeft}
  </span>;
  const trailing = <span aria-hidden="true" className={`ribbon-btn__activity${!iconRight ? " ribbon-btn__activity--idle" : ""}`}>
    {iconRight}
  </span>;
  return <BundledButton {...rest} disabled={disabled || loading} aria-busy={loading ? true : rest["aria-busy"]}
    iconOnly={iconOnly} iconLeft={iconOnly ? iconLeft : loading !== undefined ? activity : iconLeft}
    iconRight={!iconOnly && loading !== undefined ? trailing : iconRight}>
    {iconOnly && loading ? activity : children}
  </BundledButton>;
}
